export function normalizeDataLayerValue(value: string): string;
export function normalizeDataLayerValue<T>(value: T): T;
export function normalizeDataLayerValue(value: unknown): unknown {
  return typeof value === 'string' ? value.toLowerCase().replaceAll(' ', '_') : value;
}

export const fillEmptyValues = <T extends Record<string, unknown>>(data: T): T => {
  const normalizedData: Record<string, unknown> = {};

  for (const key in data) {
    const preventNormalizedKey = key.startsWith('_');
    const normalizedKey = preventNormalizedKey ? key.substring(1, key.length) : key;

    const normalizedValue = preventNormalizedKey ? data[key] : normalizeDataLayerValue(data[key]);
    normalizedData[normalizedKey] = data[key] == null ? undefined : normalizedValue;
  }

  return normalizedData as T;
};

// Extracts tracking values from a link URL.
// Internal example:
//   href: /running-a-pub?tab=news#latest
//   link_page_path: /running-a-pub?tab=news#latest
//   link_domain: https://current-site-origin.example (derived via new URL(..., window.location.origin))
// External example:
//   href: https://www.greeneking.co.uk/pubs?foo=bar#results
//   link_page_path: /pubs?foo=bar#results
//   link_domain: https://www.greeneking.co.uk

export const getLinkTrackingData = (
  href: string | undefined
): { link_page_path: string; link_domain: string } => {
  try {
    const { pathname, search, hash, origin } = new URL(href ?? '', globalThis.location?.origin);
    return {
      link_page_path: `${pathname}${search}${hash}` || '/',
      link_domain: origin || '',
    };
  } catch {
    return {
      link_page_path: href?.startsWith('/') ? href : '/',
      link_domain: '',
    };
  }
};
